import Background from "../../assets/images/background/banner.jpg";
import "./contact.css";
import { Link } from 'react-router-dom';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import { useState, useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Map from "./map";
import SEO from "../seo";
export default function Contact() {

    const [sending, setSending] = useState(false);
    const [role, setRole] = useState("");
    const [plan, setPlan] = useState("");
    const [country, setCountry] = useState("India");
    const [company, setCompany] = useState("");
    const [name, setName] = useState("");
    const [lastname, setlastName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [position, setPosition] = useState("");
    const [errors, setErrors] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    const formRef = useRef();


    const validate = () => {
        const newErrors = {};
        if (!role) newErrors.role = "Please select a role";
        if (!plan) newErrors.plan = "Please select a plan";
        if (!country.trim()) newErrors.country = "Country is required";
        if (!company.trim()) newErrors.company = "Company Name is required";
        if (!name.trim()) newErrors.name = "Your Name is required";
        if (!lastname.trim()) newErrors.lastname = "Your Last Name is required";
        if (!position.trim()) newErrors.position = "Your Position Name is required";
        if (!phone.trim()) newErrors.phone = "Phone Number is required";
        if (!email.trim()) newErrors.email = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) newErrors.email = "Invalid email";
        if (!message.trim()) newErrors.message = "Message is required";
        return newErrors;
    };
    const closeModal = () => {
        setIsOpen(false);
        setRole("");
        setPlan("");
        setCountry("");
        setCompany("");
        setName("");
        setPhone("");
        setEmail("");
        setMessage("");
        setPosition("");
        setlastName("");
        setErrors({});
    };

    useEffect(() => {
        if (country) {
            const code = countries[country];
            setPhone(code || "");
        }
    }, [country]);

    const handleSubmit = (e) => {
        e.preventDefault();

        // 🔒 Captcha validation added here
        if (!checked) {
            toast.error("Please verify the captcha!");
            return;
        }

        const form = e.target;

        const templateParams = {
            firstname: form[0].value,
            lastname: form[1].value,
            email: form[2].value,
            phone: phone,
            city: form[4].value,
            subject: form[5].value,
            message: form[6].value,
        };

        emailjs
            .send(
                "service_xbhnqhe",
                "template_tziebgm",
                templateParams,
                "JQ0fA3D24t_fCRbHX"
            )
            .then(() => {
                toast.success("Your message sent successfully!");
                // --- Reset form fields ---
                form.reset();
                setPhone("");          // reset phone
                setChecked(false); // reset captcha
            })
            .catch(() => {
                toast.error("Something went wrong! Please try again.");
            });

    };

    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(false);

    const handleClick = () => {
        if (!checked && !loading) {
            setLoading(true);
            setTimeout(() => {
                setLoading(false);
                setChecked(true);
            }, 1500); // loader duration
        }
    };

    const countries = {
        "Afghanistan": "+93",
        "Albania": "+355",
        "Algeria": "+213",
        "Andorra": "+376",
        "Angola": "+244",
        "Argentina": "+54",
        "Armenia": "+374",
        "Australia": "+61",
        "Austria": "+43",
        "Azerbaijan": "+994",
        "Bahamas": "+1-242",
        "Bahrain": "+973",
        "Bangladesh": "+880",
        "Belarus": "+375",
        "Belgium": "+32",
        "Belize": "+501",
        "Benin": "+229",
        "Bhutan": "+975",
        "Bolivia": "+591",
        "Bosnia and Herzegovina": "+387",
        "Botswana": "+267",
        "Brazil": "+55",
        "Brunei": "+673",
        "Bulgaria": "+359",
        "Burkina Faso": "+226",
        "Burundi": "+257",
        "Cambodia": "+855",
        "Cameroon": "+237",
        "Canada": "+1",
        "Chile": "+56",
        "China": "+86",
        "Colombia": "+57",
        "Congo": "+242",
        "Costa Rica": "+506",
        "Croatia": "+385",
        "Cuba": "+53",
        "Cyprus": "+357",
        "Czech Republic": "+420",
        "Denmark": "+45",
        "Djibouti": "+253",
        "Dominican Republic": "+1-809",
        "Ecuador": "+593",
        "Egypt": "+20",
        "El Salvador": "+503",
        "Estonia": "+372",
        "Ethiopia": "+251",
        "Fiji": "+679",
        "Finland": "+358",
        "France": "+33",
        "Germany": "+49",
        "Greece": "+30",
        "Greenland": "+299",
        "Guatemala": "+502",
        "Honduras": "+504",
        "Hong Kong": "+852",
        "Hungary": "+36",
        "Iceland": "+354",
        "India": "+91",
        "Indonesia": "+62",
        "Iran": "+98",
        "Iraq": "+964",
        "Ireland": "+353",
        "Israel": "+972",
        "Italy": "+39",
        "Jamaica": "+1-876",
        "Japan": "+81",
        "Jordan": "+962",
        "Kazakhstan": "+7",
        "Kenya": "+254",
        "Kuwait": "+965",
        "Kyrgyzstan": "+996",
        "Laos": "+856",
        "Latvia": "+371",
        "Lebanon": "+961",
        "Lesotho": "+266",
        "Liberia": "+231",
        "Libya": "+218",
        "Lithuania": "+370",
        "Luxembourg": "+352",
        "Madagascar": "+261",
        "Malawi": "+265",
        "Malaysia": "+60",
        "Maldives": "+960",
        "Mali": "+223",
        "Malta": "+356",
        "Mauritania": "+222",
        "Mauritius": "+230",
        "Mexico": "+52",
        "Moldova": "+373",
        "Monaco": "+377",
        "Mongolia": "+976",
        "Montenegro": "+382",
        "Morocco": "+212",
        "Mozambique": "+258",
        "Myanmar": "+95",
        "Namibia": "+264",
        "Nepal": "+977",
        "Netherlands": "+31",
        "New Zealand": "+64",
        "Nicaragua": "+505",
        "Niger": "+227",
        "Nigeria": "+234",
        "North Korea": "+850",
        "Norway": "+47",
        "Oman": "+968",
        "Pakistan": "+92",
        "Panama": "+507",
        "Papua New Guinea": "+675",
        "Paraguay": "+595",
        "Peru": "+51",
        "Philippines": "+63",
        "Poland": "+48",
        "Portugal": "+351",
        "Qatar": "+974",
        "Romania": "+40",
        "Russia": "+7",
        "Rwanda": "+250",
        "Saudi Arabia": "+966",
        "Senegal": "+221",
        "Serbia": "+381",
        "Singapore": "+65",
        "Slovakia": "+421",
        "Slovenia": "+386",
        "Somalia": "+252",
        "South Africa": "+27",
        "South Korea": "+82",
        "Spain": "+34",
        "Sri Lanka": "+94",
        "Sudan": "+249",
        "Sweden": "+46",
        "Switzerland": "+41",
        "Syria": "+963",
        "Taiwan": "+886",
        "Tajikistan": "+992",
        "Tanzania": "+255",
        "Thailand": "+66",
        "Tunisia": "+216",
        "Turkey": "+90",
        "Turkmenistan": "+993",
        "Uganda": "+256",
        "Ukraine": "+380",
        "United Arab Emirates": "+971",
        "United Kingdom": "+44",
        "United States": "+1",
        "Uruguay": "+598",
        "Uzbekistan": "+998",
        "Venezuela": "+58",
        "Vietnam": "+84",
        "Yemen": "+967",
        "Zambia": "+260",
        "Zimbabwe": "+263",
    };

    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];

    return (
        <div>
            <SEO
                title="Contact Us"
                description="Get in touch We are Connected All Time to Help Your Business! &#8220;Uninterrupted Connectivity, Dedicated to Your Business. We&#8217;re Always Here to Support Your Success!&#8221; Our Head Office Address: 4th Floor, Mahalay Complex, 403, Chimanlal Girdharlal Rd, Opp. President Hotel, Vasant Vihar, Navrangpura, Ahmedabad, Gujarat 380009 Office: +91 94096 00086 Call for Help: +91 98988 [&hellip;]"
                canonical="https://www.hwplindia.com/contact-us/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/erp-crm-development-company-banner-img.png"
                keywords={pageKeywords}
            />
            <ToastContainer position="top-center" autoClose={3000} style={{ marginTop: "80px" }} />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Contact Us</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Contact Us</li>
                    </ul>
                </div>
            </section>
            <section className="contact-us-section">
                <div className="contact-us-container">
                    {/* Left Side */}
                    <div className="contact-us-left">
                        <h4 className="contact-us-subtitle">Get In Touch</h4>
                        <h2 className="contact-us-title">We are Connected All Time to Help Your Business!</h2>

                        <div className="contact-us-info">
                            <div className="info-us-block">
                                <div className="icon-careers red-bg">
                                    <i className="fas fa-map-marker-alt"></i>
                                </div>
                                <div>
                                    <h4>Our Head Office Address:</h4>
                                    <p className='p1'>
                                        4th Floor, Mahalay Complex, 403, Chimanlal Girdharlal Rd, Opp. President Hotel, Vasant Vihar, Navrangpura, Ahmedabad, Gujarat 380009
                                    </p>
                                </div>
                            </div>

                            <div className="info-us-block">
                                <div className="icon-careers red-bg">
                                    <i className="fas fa-phone"></i>
                                </div>
                                <div>
                                    <h4>Office:</h4>
                                    <p>+91 94096 00086</p>
                                </div>
                            </div>

                            <div className="info-us-block">
                                <div className="icon-careers red-bg">
                                    <i className="fas fa-headset"></i>
                                </div>
                                <div>
                                    <h4>Call for Help:</h4>
                                    <p>+91 98988 76310</p>
                                </div>
                            </div>

                            <div className="info-us-block">
                                <div className="icon-careers red-bg">
                                    <i className="fas fa-envelope"></i>
                                </div>
                                <div>
                                    <h4>Mail Us for Information</h4>
                                    <p>info@hwplindia.com</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Side */}
                    <div className="contact-us-right">
                        <div className="right-title-contact">“Uninterrupted Connectivity, Dedicated to Your Business. We’re Always Here to Support Your Success!”</div>
                        <form className="form contact-form" ref={formRef} onSubmit={handleSubmit}>
                            <div className="form-row">
                                <input type="text" placeholder="First Name*" required />
                                <input type="text" placeholder="Last Name*" required />
                            </div>

                            <div className="form-row1">
                                <input type="email" placeholder="Email*" required />
                                <PhoneInput
                                    country={'in'} // default India 🇮🇳
                                    value={phone}
                                    onChange={setPhone}
                                    inputClass="phone-input"
                                    buttonClass="phone-flag"
                                    enableSearch={true} // allow search in dropdown
                                />
                            </div>
                            <div className="form-row">
                                <input type="text" placeholder="City" />
                                <input type="text" placeholder="Subject" />
                            </div>

                            <textarea
                                placeholder="Message"
                                rows="3"
                            ></textarea>

                            <div className="recaptcha-box" onClick={handleClick}>
                                <div className="recaptcha-left">
                                    <div
                                        className={`checkmark-box ${loading ? "loading" : checked ? "checked" : ""
                                            }`}
                                    >
                                        {!loading && !checked && <div className="empty-box"></div>}
                                        {loading && <div className="spinner"></div>}
                                        {checked && <div className="tick">✓</div>}
                                    </div>
                                    <span className="captcha-text">I'm not a robot</span>
                                </div>

                                <div className="recaptcha-right">
                                    <img
                                        src="https://www.gstatic.com/recaptcha/api2/logo_48.png"
                                        alt="reCAPTCHA"
                                        className="captcha-logo"
                                    />
                                    <p>
                                        reCAPTCHA<br />
                                        <span>Privacy - Terms</span>
                                    </p>
                                </div>
                            </div>



                            <button type="submit" className="send-btn">
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
            </section>
            <Map />
        </div>
    );
}